export const DEFAULT_ANIMATION_DURATION_MS = 300;
export const DEFAULT_ANIMATION_DURATION = `${DEFAULT_ANIMATION_DURATION_MS}ms`;
export const FADING_CURTAINS_DURATION_MS = 500;
export const EASE = 'ease-in-out';
